<app-spinner></app-spinner>
<ng-container>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="notificationForm" novalidate>
      <div class="row mt-3">
        <div class="col-4">
          <label for="title" class="text-black-1">Title</label>
        </div>
        <div class="input-group col-8">
          <input
            id="title"
            class="form-control rb-input"
            placeholder="Please enter notification title."
            formControlName="title"
            name="title"
            type="text"
          />
          <div class="col-12 error-mssg" *ngIf="(f.title.touched || isFormSubmitted) && f.title.errors">
            <label for="title" class="text-danger" *ngIf="f.title.errors.required"
              >*Please enter notification title.</label
            >
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="body" class="text-black-1">Body</label>
        </div>
        <div class="input-group col-8">
          <input
            id="body"
            class="form-control rb-input"
            placeholder="Please enter notification body."
            formControlName="body"
            name="body"
            type="text"
          />
          <div class="col-12 error-mssg" *ngIf="(f.body.touched || isFormSubmitted) && f.body.errors">
            <label for="body" class="text-danger" *ngIf="f.body.errors.required"
              >*Please enter notification body.</label
            >
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="body" class="text-black-1">Notification type</label>
        </div>
        <div class="input-group col-8">
          <div>
            <input
              class="form-control rb-input"
              id="user-based"
              type="radio"
              value="user"
              name="notificationType"
              formControlName="notificationType"
              (change)="changeNotificationType($event)"
            />
            <label for="user-based">User based</label>
          </div>
          <div class="ml-3">
            <input
              class="form-control rb-input"
              id="topic-based"
              type="radio"
              value="topic"
              name="notificationType"
              formControlName="notificationType"
              (change)="changeNotificationType($event)"
            />
            <label for="topic-based">Topic based</label>
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="userDropDownList && selectedNotificationType === 'user'">
        <div class="col-4">
          <label for="select-users" class="text-black-1">Select users</label>
        </div>
        <div class="input-group col-8">
          <ng-multiselect-dropdown
            class="wd-100"
            [placeholder]="'Select user by email id.'"
            [data]="userDropDownList"
            formControlName="usersTokens"
            [settings]="dropdownSettings"
          >
          </ng-multiselect-dropdown>
        </div>
      </div>

      <div class="row mt-3" *ngIf="selectedNotificationType === 'topic'">
        <div class="col-4">
          <label for="topic" class="text-black-1">Topic</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="ntypeFields"
            optionLabel="viewValue"
            (onChange)="selectNotificationTopic($event)"
            formControlName="topic"
            placeholder="Select if you want to send the notifications to specific topics."
          ></p-dropdown>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <span class="error-danger">
      *You can either send the notifications to the list of users or you can send the notification to all thhe users who
      have subscribed to a perticular topic.
    </span>
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading" (click)="save()">Submit</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</ng-container>
